/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 02.10.12, 17:52
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */
import {AbstractJavascriptFunctionCallVO} from "./AbstractJavascriptFunctionCallVO";

export class JavascriptCallDefaultVO implements AbstractJavascriptFunctionCallVO {
    public parameters = [];

    constructor(public functionName: string) {
    }
}
